export const GET_BOOKED_SLOTS_ENDPOINT = '/booking-portal/Appointment/GetTotalBookedSlots';
